export abstract class FormulaCalculatorUtils {
	/**
	 * This file should be kept identical in both AdminUI and AWS-Stack.
	 */
	public static addParamsToFormula(params: Record<string, unknown>, formula: string): string {
		//init all standard vars
		let fnStart = '';
		//set vars for function to be set at top of file
		for (const [key, value] of Object.entries(params)) {
			if (value === undefined) {
				continue;
			}
			if (typeof value === 'number') {
				fnStart += `var ${key} = ${value}\n`;
			} else {
				fnStart += `var ${key} = "${value}"\n`;
			}
		}

		return fnStart + '\n' + formula;
	}

	/**
	 * Corrections are modifications to the parameters, where a correction exists
	 * for a parameter add the correction value to the parameter value if number
	 *
	 */
	public static appendParametersWithCorrections(
		parameters: Record<string, number | string>,
		correction: Record<string, number | string | null>,
	): Record<string, number | string> {
		const appendedParams = JSON.parse(JSON.stringify(parameters));
		const keys = Object.keys(appendedParams);

		for (const key of keys) {
			let paramVal = appendedParams[key];
			if (paramVal !== null && !isNaN(+paramVal)) {
				paramVal = +paramVal;

				const correctionVal = correction[key];
				if (correctionVal !== null && !isNaN(+correctionVal)) {
					appendedParams[key] = paramVal + +correctionVal;
				}
			}
		}

		return appendedParams;
	}
}
